/* eslint-disable @typescript-eslint/naming-convention */
import { AxiosResponse, AxiosError } from "axios";
import request from "#/utils/request";
import InternalResponse from "#/types/internalResponse";
import { baseAuthHeaders } from "#/modules/auth/idp";

// One Territory (internal scope = CUSTOMER). UI term Territory; code keeps customer_*.
export type CustomerItem = {
  customer_id: string;
  customer_cid?: string;
  customer_name: string;
  customer_status: string;
  max_users: number;
  effective_role: string;
};

type ListCustomersResponse = { items: CustomerItem[] };

// GET /customers — Territories accessible to the caller (SYSTEM_ADMIN: all; TERRITORY_ADMIN:
// their own). Internal-Admin plane: BearerAuth only, license-independent (like listLicenses).
export default function listCustomers(
  { token }: { token: string },
): Promise<InternalResponse<ListCustomersResponse>> {
  return request()<ListCustomersResponse>({
    url: "/xecguard/internal/v1/customers",
    method: "GET",
    headers: baseAuthHeaders(token),
  }).then(
    (result: AxiosResponse<ListCustomersResponse>): InternalResponse<ListCustomersResponse> => ({
      statusCode: result.status,
      data: result.data,
      success: true,
    }),
  ).catch((error: AxiosError): InternalResponse => ({
    statusCode: error.response?.status ?? error.code,
    msg: error.message,
    success: false,
  }));
}
